import { render, staticRenderFns } from "./helpdesk.vue?vue&type=template&id=33a679e3&scoped=true"
import script from "./helpdesk.js?vue&type=script&lang=js&external"
export * from "./helpdesk.js?vue&type=script&lang=js&external"
import style0 from "./helpdesk.scss?vue&type=style&index=0&id=33a679e3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a679e3",
  null
  
)

export default component.exports